module.exports = __webpack_public_path__ + "img/world_of_acredo.9232600.png";